<template>
  <div class="all-style-bgc">
    <div class="container">
      <div class="title-tab">
        <span>当前位置：</span>
        <span @click="GoreportInternet">清风论坛></span>
        <span @click="GoreportEvaluation">亦廉课堂></span>
        <span class="red">正文</span>
      </div>
      <!--正文内容-->
      <div class="text">
        <h1>杨彪带队到保康开展“两严”检查</h1>
        <h2><span class="mg-16">来源：新华社</span>|<span class="mg-16">发布时间：2020-03-30&nbsp;13:30</span></h2>
        <div class="PIC-BOX">
          <img :src="PicBannertest1" alt />
        </div>
        <h3>“整治形式主义官僚主义，你们有哪些具体措施？成效有哪些？</h3>
        <h3>“坚持明察暗访、严查快办，强化执纪问责、通报曝光，1-5月，共查处形式主义官僚主义问题19个，问责22人，其中党纪政务处分5人，组织处理17人。”……</h3>
        <h3>7月7日至9日，由市委常委、市公安局局长杨彪带队，市纪委常委、监委委员钱鑫任组长的“两严”专项督查组在保康开展严守政治纪律、严明政治规矩专项监督检查。</h3>
        <h3>督查组采取个别座谈+问卷调查+现场测试+实地抽查等方式，重点对学习贯彻上级精神、开展形式主义官僚主义整治、贯彻落实重点工作、落实党内政治生活制度规定、贯彻落实《党委（党组）落实全面从严治党主体责任规定》、落实意识形态责任制等六个方面情况开展监督检查。</h3>
        <h3>杨彪对该县迅速开展自查自纠，强化软弱涣散村党组织整顿等做法给予充分肯定。他指出，保康高度重视“两严”落实和党建工作，领导包保责任上肩、对症施策抓整改、实地检查效果好，要持续提高认识、压实责任、紧盯问题、完善制度、建强队伍、巩固成果，全力冲刺脱贫攻坚目标、化解疫后综合症、做好防汛抢险准备，统筹抓好当前各项重点工作。</h3>
        <h3>钱鑫要求，要不断提高政治站位，增强政治定力，始终把严守政治纪律、严明政治规矩摆在首要位置，抓牢抓实全面从严治党主体责任，让政治纪律严起来、政治规矩立起来，营造风清气正政治生态，促进党员干部干事创业。</h3>
        <h3>“通过此次督查，我们更加深刻地认识到严守政治纪律和政治规矩的极端重要性。”该县县委常委、纪委书记、监委主任刘三元表示，全县纪检监察组织要从严执纪、敢抓敢管，对违反政治纪律和政治规矩的坚决制止、严肃处理，为推动党中央重大决策部署和省委市委工作要求在基层落地见效提供坚强保证。</h3>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      PicBannertest1: require("../../../../assets/image/ylkt5-1.jpg"),
    };
  },
  methods: {
    GoreportInternet() {
      this.$router.push("/forum");
    },
    GoreportEvaluation() {
      this.$router.push({ name: "forumClassroom" });
    }
  }
};
</script>

<style lang="less" scoped>
.container {
  width: 1200px;
  margin: 0 auto;
}
/*副导航兰*/
.title-tab {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  line-height: 54px;
  cursor: pointer;
}
.red {
  color: red;
}
/*问卷调查正文*/
.text {
  background-color: white;
  padding: 44px 60px 121px 60px;
  margin: 0 auto;
}
.text h1 {
  font-size: 28px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  line-height: 56px;
  text-align: center;
}
.text h2 {
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
  line-height: 44px;
  text-align: center;
  padding-bottom: 14px;
  border-bottom: 1px solid #E8E8E8;
  margin-bottom: 15px;
}
.text h3 {
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  line-height: 32px;
  text-indent: 2em;
  margin-bottom: 30px;
}
/*静态页面样式 */
.PIC-BOX {
  display: flex;
  justify-content: center;
}
img {
  margin: 20px 0;
}
.mg-16{
  margin: 0px 16px;
}
</style>